module.exports = __webpack_public_path__ + "static/media/share-black.e9349817.svg";